import { createAction } from 'redux-actions';
import * as types from './publish-steps-constants';

export const unlockLockRequest = createAction(types.UNLOCK_LOCK_REQUEST);
export const unlockLockSuccess = createAction(types.UNLOCK_LOCK_SUCCESS);
export const unlockLockFailure = createAction(types.UNLOCK_LOCK_FAILURE);

export const discardLockRequest = createAction(types.DISCARD_LOCK_REQUEST);
export const discardLockSuccess = createAction(types.DISCARD_LOCK_SUCCESS);
export const discardLockFailure = createAction(types.DISCARD_LOCK_FAILURE);

export const currentStatusRequest = createAction(types.CURRENT_STATUS_REQUEST);
export const currentStatusSuccess = createAction(types.CURRENT_STATUS_SUCCESS);
export const currentStatusFailure = createAction(types.CURRENT_STATUS_FAILURE);

export const startPublishStepPoll = createAction(types.START_PUBLISH_STEP_POLL);
export const stopPublishStepPoll = createAction(types.STOP_PUBLISH_STEP_POLL);

export const resetOperationInfo = createAction(types.RESET_OPERATION_INFO);

export const multiStatusRequest = createAction(types.MULTI_STATUS_REQUEST);
export const multiStatusSocketRequest = createAction(types.MULTI_STATUS_SOCKET_REQUEST);
export const multiStatusSuccess = createAction(types.MULTI_STATUS_SUCCESS);
export const multiStatusFailure = createAction(types.MULTI_STATUS_FAILURE);

export const startMultiStatusPoll = createAction(types.START_MULTI_STATUS_POLL);
export const stopMultiStatusPoll = createAction(types.STOP_MULTI_STATUS_POLL);


export const setIdsToPoll = createAction(types.SET_IDS_TO_POLL);

export const abortRequest = createAction(types.ABORT_REQUEST);
export const abortSuccess = createAction(types.ABORT_SUCCESS);
export const abortFailure = createAction(types.ABORT_FAILURE);

export const resetAbort = createAction(types.RESET_ABORT);

export const resetMultiPolling = createAction(types.RESET_MULTI_POLLING);
